import { Box } from './Box';
import { TablePaginationBar } from './TablePaginationBar';
import { tablePaginationChromeSx, tablePaginationFooterContainerSx } from './tablePaginationChrome';
import type { SxProps, Theme } from '@mui/material/styles';
import type { TablePaginationProps as MuiTablePaginationProps } from '@mui/material/TablePagination';
import type { ChangeEvent, ReactNode } from 'react';
import type { ReactElement } from 'react';

type TablePaginationFooterProps = Omit<
  MuiTablePaginationProps,
  'ActionsComponent' | 'component' | 'sx'
> & {
  sx?: SxProps<Theme>;
  containerSx?: SxProps<Theme>;
};

export const TablePaginationFooter = ({
  containerSx,
  sx: _sx,
  count,
  labelDisplayedRows,
  labelRowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  page,
  rowsPerPage,
  rowsPerPageOptions,
  showFirstButton: _showFirstButton,
  showLastButton: _showLastButton,
  slotProps: _slotProps,
  slots: _slots,
  ...props
}: TablePaginationFooterProps): ReactElement => {
  const handleRowsPerPageChange = (nextRowsPerPage: number): void => {
    if (!onRowsPerPageChange) {
      return;
    }

    const event = {
      target: { value: String(nextRowsPerPage) },
    } as ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;
    onRowsPerPageChange(event);
  };

  return (
    <Box
      sx={
        (containerSx
          ? [tablePaginationFooterContainerSx, tablePaginationChromeSx, containerSx]
          : [tablePaginationFooterContainerSx, tablePaginationChromeSx]) as SxProps<Theme>
      }
    >
      <TablePaginationBar
        count={count}
        disabled={props.disabled}
        getItemAriaLabel={props.getItemAriaLabel}
        labelDisplayedRows={labelDisplayedRows}
        labelRowsPerPage={labelRowsPerPage as ReactNode}
        onPageChange={onPageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={rowsPerPageOptions}
      />
    </Box>
  );
};
